import React from "react";

const ACCENT = "#D2042D";

const cx = (...arr) => arr.filter(Boolean).join(" ");

export default function AdminPageShell({
  title,
  description,
  chips,
  actions,
  children,
  containerClassName,
  pageClassName,
}) {
  return (
    <div className={cx("min-h-screen bg-white", pageClassName)}>
      <div className={cx("max-w-[1440px] mx-auto px-4 md:px-6 py-6 md:py-8", containerClassName)}>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-6 md:mb-8">
          <div className="min-w-0">
            <div className="flex items-center gap-2">
              <span className="h-6 w-[3px] rounded-full" style={{ background: ACCENT }} />
              <h1 className="text-2xl md:text-3xl font-black tracking-tight text-slate-900">
                {title}
              </h1>
            </div>
            {description ? (
              <p className="mt-2 text-sm text-slate-600">{description}</p>
            ) : null}
            {chips ? (
              <div className="mt-3 flex flex-wrap items-center gap-2">{chips}</div>
            ) : null}
          </div>

          {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
        </div>

        {children}
      </div>
    </div>
  );
}
